import { useTranslation } from "react-i18next";
import { Play, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTour } from "@/hooks/useTour";

export const HelpActions = () => {
	const { t } = useTranslation();
	const tour = useTour();
	const supportEmail = t("help.actions.supportEmail");

	return (
		<div className="flex flex-wrap items-center gap-2">
			<Button variant="outline" onClick={tour.start}>
				<Play className="h-4 w-4 mr-2" />
				{t("help.actions.restartTour")}
			</Button>
			<Button variant="outline" asChild>
				<a href={`mailto:${supportEmail}`}>
					<Mail className="h-4 w-4 mr-2" />
					{t("help.actions.contactSupport")}
				</a>
			</Button>
		</div>
	);
};
